import { DatePipe } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { ActivatedRoute } from '@angular/router';
import { UserReplacePipe } from '../../../pipes/user-replace.pipe';

import { ModificationLog } from 'src/app/models/modification';
import { ModificationLogService } from 'src/app/services/modificationlog.service';
import { RecommendationService } from 'src/app/services/recommendation.service';

import { Recommendation } from '../../../models/recommendation/recommendation';

@Component({
  selector: 'app-recommendation-logs',
  templateUrl: './recommendation-logs.component.html',
  styleUrls: ['./recommendation-logs.component.scss'],
  imports: [MatCardModule, MatListModule, DatePipe, UserReplacePipe],
  providers: [DatePipe]
})
export class RecommendationLogsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  modificationLogService = inject(ModificationLogService);
  recommendationService = inject(RecommendationService);
  readonly recommendations = input.required<Recommendation>();

  prolongationHistory!: string;

  currentTab = 0;
  modificationLogs!: ModificationLog[];

  ngOnInit() {
    this.currentTab = this.route.snapshot.params?.tab;
    this.loadModifications();
    this.getProlongationHistory();
  }

  loadModifications() {
    this.modificationLogService.getModificationLogs(this.recommendations().id).subscribe({
      next: (modificationLog: ModificationLog[]) => {
        this.modificationLogs = modificationLog;
      }
    });
  }

  isAuditor(auditor: string) {
    return this.recommendations()?.auditor === auditor;
  }

  getProlongationHistory() {
    this.recommendationService.getProlongationHistory(this.recommendations().id).subscribe({
      next: (history) => {
        this.prolongationHistory = '<p>' + history.map((his) => his.entry).join('</p><p>') + '</p>';
      }
    });
  }
}
